import { Injectable } from '@angular/core';
import { PaymentsLinkService } from '@paymash/sdk/util';
import { appIndicatorType } from '@paymash/sdk/common';
import { Store } from '@ngrx/store';
import { PaymentQueryParamsType } from '@paymash/sdk/util/lib/types';
import { PaymentStatusEnum } from '@modules/core/enums';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private paymentsLinkService: PaymentsLinkService, private store: Store) {}

  private get origin(): string {
    return window.location.origin;
  }

  private basePath(companyUuid: string): string {
    return `${this.origin}/${companyUuid}/booking`;
  }

  private generateSuccessUrl(companyUuid: string, storeUuid: string, appointmentUuid: string): string {
    const path = this.basePath(companyUuid);
    const objectUrl = new URL(`${path}/thank-you`);

    objectUrl.searchParams.append('storeUuid', storeUuid);
    objectUrl.searchParams.append('appointmentUuid', appointmentUuid);
    objectUrl.searchParams.append('paymentStatus', PaymentStatusEnum.SUCCESS);

    return objectUrl.toString();
  }

  private generateFailUrl(companyUuid: string, storeUuid: string, appointmentUuid: string): string {
    const path = this.basePath(companyUuid);
    const objectUrl = new URL(`${path}/confirm`);

    objectUrl.searchParams.append('storeUuid', storeUuid);
    objectUrl.searchParams.append('appointmentUuid', appointmentUuid);
    objectUrl.searchParams.append('paymentStatus', PaymentStatusEnum.FAILURE);

    return objectUrl.toString();
  }

  private generateReturnUrl(companyUuid: string, storeUuid: string, appointmentUuid: string): string {
    const path = this.basePath(companyUuid);
    const objectUrl = new URL(`${path}/confirm`);

    objectUrl.searchParams.append('storeUuid', storeUuid);
    objectUrl.searchParams.append('appointmentUuid', appointmentUuid);

    return objectUrl.toString();
  }

  private get appIndicator(): appIndicatorType {
    return 'booking';
  }

  public generatePaymentLink(params: {
    companyUuid: string;
    invoiceUuid: string;
    storeUuid: string;
    appointmentUuid: string;
  }): string {
    const urlParams: PaymentQueryParamsType = {
      appIndicator: this.appIndicator,
      invoiceUuid: params.invoiceUuid,
      failUrl: this.generateFailUrl(params.companyUuid, params.storeUuid, params.appointmentUuid),
      successUrl: this.generateSuccessUrl(params.companyUuid, params.storeUuid, params.appointmentUuid),
      returnUrl: this.generateReturnUrl(params.companyUuid, params.storeUuid, params.appointmentUuid),
    };

    return this.paymentsLinkService.generatePaymentProcessLink(urlParams);
  }
}
